import React, { useEffect, useMemo, useRef, useState } from "react";
import GlobalContacts from "./GlobalContacts";
import GenericTabs from "../genericComponents/GenericTabs";
import { useSearchParams, useLocation, useParams } from "react-router-dom"; // **New Imports**
import SavedGlobalContacts from "./SavedGlobalContacts";
import { pxToRem } from "../../../utilities/uiUtils";
import { useUser } from "../../../context/UserContext"; // **New Import**
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../services/commonService"; // **New Import**
import { deleteContactFilter, getSavedGlobalContactsPerUserId, saveGlobalContactsInList } from "../../../services/iqApiV2";
import { useBanner } from "../../../context/BannerContext";

function GlobalContactsWrapper() {
    const showBanner = useBanner();
   const [tabs, setTabs] = useState([{defaultList: true ,id : Date.now()+"all_contacts_tab" ,name: "All Contacts"}]);
     const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = "global_contact_tabs";
  const activeTabFromUrl = searchParams.get("tab") || defaultTab;
  const activeSubTabFromUrl = searchParams.get("subTab"); // Get subTab for logging
  const [activeParentTabKey, setParentActiveTab] = useState(activeTabFromUrl);
  
  const { user } = useUser(); // **Added**
  const location = useLocation(); // **Added**
  const pageParsedData = getUrlDetailsObj(useLocation, useParams); // **Added**

  // --- LOGGING ON MOUNT/REFRESH (Independent of default setting) ---
  useEffect(() => {
    // 1. Guard check: Ensure user is logged in and on the correct parent tab
    if (!user?.id || activeParentTabKey !== defaultTab) {
      return;
    }
    
    // 2. Map sub-tab to the desired log name
    const tabTypeMap = {
      "find_global_contacts": "Find Contacts",
      "saved_global_contacts": "Saved Global Contacts",
    };
    
    const pageName = tabTypeMap[activeSubTabFromUrl];

    // 3. Only log if we are on one of the tracked sub-tabs
    if (pageName) {
      const actionType = "page_load";
      const dataDetails = `Page Load: ${pageName}`;
      const contextualId = user.id; // Use user ID for context

      const userStat = getUserStatsObject(
          pageName, // Log now shows "Find Contacts" or "Saved Global Contacts"
          actionType,
          dataDetails,
          window.location.href, 
          contextualId
      );
      
      pageParsedData.query_params = { 
          tab: activeParentTabKey,
          subTab: activeSubTabFromUrl 
      };
      userStat.url_details = pageParsedData;

      recordActivity(userStat);
    }

  }, [activeParentTabKey, activeSubTabFromUrl, user?.id, location.pathname]);
  // --- END LOGGING FIX ---

  const handlePostOnSave=async()=>{
    const response = await getSavedGlobalContactsPerUserId(user?.id);
          setTabs(Array.isArray(response) ? response : []);
  }


useEffect(() => {
  const subTab = searchParams.get("subTab");
  if (!subTab) {
    const debounceTimer = setTimeout(() => {
      setSearchParams({
        tab: activeParentTabKey,
        subTab: "find_global_contacts",
      });
    }, 100);
    return () => clearTimeout(debounceTimer);
  }
}, [activeParentTabKey, setSearchParams, searchParams]);
            const initPayload = {
  "user_id": user?.id,
  "name": "All Contacts",
  "selected_contacts": [],
  "filters": {
    "additionalProp1": {
      "contact_email_status": [],
      "page": 1,
      "per_page": 15,
      "person_locations": [],
      "person_seniorities": [],
      "revenue_range": [],
      "domains": "",
      "job_Title": "",
      "org_Head_Count": [],
      "contacts": [],
      "defaultList":true,
    }
  }
}
const subTab = useMemo(() => searchParams.get("subTab"), [searchParams]);

useEffect(() => {
  if (!user?.id) return;

  const fetchContacts = async () => {
    setLoading(true);

    try {
      let response = await getSavedGlobalContactsPerUserId(user.id);

      setTabs(Array.isArray(response) ? response : []);
    } catch (err) {
      console.error("Error fetching saved global contacts:", err);
      setTabs([]);
    } finally {
      setLoading(false);
    }
  };

  if (subTab === "saved_global_contacts" || subTab === "find_global_contacts") {
    fetchContacts();
  }

  return ()=>{
    Object.keys(localStorage).forEach((k) => {
  if (k.endsWith("_phone_pending")) {
    const obj = JSON.parse(localStorage.getItem(k));
    const oneHour = 60 * 60 * 1000;
    if (Date.now() - obj.ts > oneHour) {
      localStorage.removeItem(k);
    }
  }
});

  }
}, [user?.id, subTab]);


  const handleDeleteList = async (id) => {
    try {
      await deleteContactFilter(id);
      showBanner({
        message: "List Deleted!",
        title: "Alert",
        type: "success",
        duration: 1000,
      });
    } catch (error) {
      showBanner({
        message: "List Deletion failed!",
        title: "Alert",
        type: "error",
        duration: 1000,
      });
    } finally {
      setTabs((prev) => prev.filter((l) => l.id !== id));
    }
  };




  const tabData = [
    {
      tabId: "find_global_contacts",
      label: "Find Contacts",
      comp: <GlobalContacts initialListItems={tabs} postOnSave={handlePostOnSave} />,
    },
    {
      tabId: "saved_global_contacts",
      label: "Saved Contacts",
      comp: <SavedGlobalContacts tabs={tabs} loading={loading} handleDeleteList={handleDeleteList}/>,
    },
  ];

  return <div style={{
    // position:"absolute",
          backgroundColor: "#fff",
          // height: "100%",
          borderRadius: pxToRem(10),
          padding: pxToRem(10),
        }}>
  <GenericTabs tabs={tabData} /></div>;
}

export default GlobalContactsWrapper;
